var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MenuInlineStyle from './MenuInlineStyle';
import MenuContext from '../MenuContext';
import BackDrop from '../../BackDrop/BackDrop';
import useDebounce from '../../../utils/hooks/useDebounce';
const MenuInline = (_a) => {
    var { children, onExpand, hasBackDrop, backdropOpacity, zIndexOffset } = _a, otherProps = __rest(_a, ["children", "onExpand", "hasBackDrop", "backdropOpacity", "zIndexOffset"]);
    const [menuOpen, setMenuOpen] = React.useState(false);
    // prevents the component from flickering when you hover to the next menu items
    const handleOnExpand = useDebounce((expand) => {
        setMenuOpen(expand);
        return onExpand && onExpand(expand);
    }, 50);
    return (React.createElement(MenuContext.Provider, { value: {
            onExpand: handleOnExpand,
        } },
        React.createElement(MenuInlineStyle, Object.assign({ hasBackDrop: hasBackDrop }, otherProps), children),
        hasBackDrop && menuOpen && (React.createElement(BackDrop, { onClick: handleOnExpand, backdropOpacity: backdropOpacity, zIndexOffset: zIndexOffset }))));
};
export default MenuInline;
//# sourceMappingURL=MenuInline.js.map